module.exports = __webpack_public_path__ + "img/livro3.98be0496.jpg";